import { CaptionLight, MediaQuery } from '@pelando/components';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 4px 0;
  column-gap: 4px;
`;

export const Reaction = styled.div`
  ${CaptionLight}
  display: flex;
  align-items: center;
  column-gap: 4px;
  padding: 0 16px 0 12px;
  min-width: 40px;
  height: 40px;
`;

export const WrapperImage = styled.div`
  width: 16px;
  height: 16px;
`;

export const ReactionModalStyle = css`
  @media ${MediaQuery.SCREEN_MD_UP} {
    width: 391px;
  }
`;
